<!-- 供水量分析 -->
<template>
  <a-row :gutter="24" class="new-row">
    <a-col :md="collapsed ? 0 : 5" :sm="24" class="new-col">
      <a-row :gutter="10" class="new-row">
        <a-card :bordered="false" class="new-tree-card">
          <AreaTreeCard
            ref="areaTreeCard"
            :area-loading="areaLoading"
            :area-tree="areaTree"
            :curr-selected="currSelected"
            @node-selected="handleNodeSelected"
            @node-unselected="handleNodeUnselected"
            @unselect="resetAareaData"
            @collapse-all="collapseTree"
            @area-add="handleAreaAdd"
            @add-child="handleAdd"
            @delete="handleDelete"
            @toggle-visibility="handleTreeToggle"
          />
        </a-card>
      </a-row>
    </a-col>
    <a-col :md="collapsed ? 24 : 19" :sm="24" style="position: relative; padding-left: 30px" class="new-col">
      <a-icon
        :type="collapsed ? 'caret-right' : 'caret-left'"
        @click="collapsed = !collapsed"
        class="area-collapsed"
      ></a-icon>
      <a-card :bordered="false">
        <!-- 查询区域 -->
        <div class="table-page-search-wrapper">
          <a-form layout="inline" @keyup.enter.native="searchQuery">
            <a-row :gutter="24">
              <a-col :xl="8" :lg="7" :md="8" :sm="24">
                <a-form-item :label="$t('日期')">
                  <a-range-picker
                    v-model="date"
                    value-format="YYYY-MM-DD"
                    :placeholder="$t('请选择日期')"
                    style="width: 100%"
                  />
                </a-form-item>
              </a-col>
              <a-col :xl="6" :lg="7" :md="8" :sm="24">
                <span style="float: left; overflow: hidden" class="table-page-search-submitButtons">
                  <a-button type="primary" @click="searchQuery" icon="search">{{ $t('查询') }}</a-button>
                  <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{ $t('重置') }}</a-button>
                </span>
              </a-col>
            </a-row>
          </a-form>
        </div>
        <!-- 查询区域-END -->

        <!-- table区域-begin -->
        <div>
          <a-table
            ref="table"
            size="middle"
            :scroll="{ x: true }"
            bordered
            rowKey="id"
            :columns="columns"
            :dataSource="dataSource"
            :pagination="ipagination"
            :loading="loading"
            class="j-table-force-nowrap"
            @change="handleTableChange"
          >
          </a-table>
        </div>
      </a-card>
    </a-col>
  </a-row>
</template>
          
  <script>
import '@/assets/less/TableExpand.less'
import { mixinDevice } from '@/utils/mixin'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import { httpAction, getAction, postAction } from '@/api/manage'
import JInput from '@/components/jeecg/JInput'
import { AreaChoosetMixin } from '@/mixins/AreaChooseMixin'
import AreaTreeCard from '../AreaTreeCard.vue'
import axios from 'axios'
export default {
  name: 'WaterSupplyAnalysis',
  mixins: [JeecgListMixin, AreaChoosetMixin, mixinDevice],
  components: {
    JInput,
    AreaTreeCard,
  },
  data() {
    return {
      description: '供水量分析',
      collapsed: false,
      url: {
        list: '/mock/WaterSupplyAnalysis',
      },
      date: [],
      dataSource1: [
        {
          id: 1,
          partitionName: '0号分区',
          date: '2025-02-02',
          totalValue: 0,
        },
        {
          id: 2,
          partitionName: '1号分区',
          date: '2025-06-23',
          totalValue: 0,
        },
        {
          id: 3,
          partitionName: '2号分区',
          date: '2025-04-10',
          totalValue: 0,
        },
        {
          id: 4,
          partitionName: '3号分区',
          date: '2025-04-24',
          totalValue: 0,
        },
        {
          id: 5,
          partitionName: '4号分区',
          date: '2025-04-14',
          totalValue: 0,
        },
        {
          id: 6,
          partitionName: '5号分区',
          date: '2025-04-27',
          totalValue: 0,
        },
        {
          id: 7,
          partitionName: '6号分区',
          date: '2025-08-01',
          totalValue: 0,
        },
        {
          id: 8,
          partitionName: '7号分区',
          date: '2025-01-08',
          totalValue: 0,
        },
      ],
    }
  },
  created() {},
  computed: {
    // i18n：表头使用 computed 以响应语言切换
    columns() {
      return [
        {
          title: this.$t('序号'),
          dataIndex: '',
          key: 'rowIndex',
          width: 60,
          align: 'center',
          customRender: (t, r, index) => {
            return parseInt(index) + 1
          },
        },
        {
          title: this.$t('时间'),
          align: 'center',
          dataIndex: 'date',
        },
        {
          title: this.$t('分区名称'),
          align: 'center',
          dataIndex: 'partitionName',
        },
        {
          title: this.$t('累计用量(m³)'),
          align: 'center',
          dataIndex: 'totalValue',
        },
      ]
    },
  },
  methods: {
    // async loadData() {
    //   try {
    //     let params = this.getQueryParams()
    //     params.startDate = this.date[0]
    //     params.endDate = this.date[1]
    //     const res = await axios.post(this.url.list, params)
    //     if (res.data.code == 200) {
    //       this.dataSource = res.data.result.records
    //       this.ipagination.total = res.data.result.total
    //     } else {
    //       this.dataSource = []
    //       this.ipagination.total = 0
    //       this.$message.error(res.data.message)
    //     }
    //   } catch (err) {
    //     console.log(err)
    //   }
    // },
    loadData() {
      if(this.date.length == 0) {
        this.dataSource = this.dataSource1
      }else{
        this.dataSource = this.dataSource1.filter(item => {
          return item.date >= this.date[0] && item.date <= this.date[1]
        })
      }
    }
  },
}
</script>
          <style scoped>
@import '~@assets/less/common.less';
</style>